import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import plus from "../../../Components/assets/icons/a1.png";
import colunms from "../../../Components/assets/icons/LINES.png";
import search1 from "../../../Components/assets/icons/search.png";
import top from "../../../Components/assets/icons/top.png";
import Table from "react-bootstrap/Table";
import { Link } from "react-router-dom";
import Header from "../../Header/Header";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import toast, { Toaster } from "react-hot-toast";
import AddOffCanvance from "./Add";
import EditOffCanvance from "./Edit";
import ModalDelete from "../../common/ModelDelete";
import ModelBulkUpload from "../../common/ModelBulkUpload";
import { AddButton, EditButton, DeletButton } from "../../common/Button";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import { Button, Col, Row } from "react-bootstrap";
import OffcanvasCon from "../../OffcanvasCon/OffcanvasCon";
import DataTable from "datatables.net";
import { IDS } from "../../../utils/common";
import Pagination_Holder from "../../common/Pagination_Holder/Pagination_Holder";
import Pagination from "react-bootstrap/Pagination";

library.add(fas);

const Tables = () => {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    Per_Page_Dropdown,
    postData,
    getDownloadDataExcel,
    isAllow,
    IMG_URL,
  } = useContext(Context);

  const [data, setData] = useState([]);
  const [show, setShowAdd] = useState(false);
  const [show1, setShowEdit] = useState(0);
  const [showoff, setShowoff] = useState(false);
  const getDataAll = async () => {
    const response = await getData(`/admin/subscription/my-subscription`);
    await setData(response?.data);
  };

  useEffect(() => {
    getDataAll();
  }, [show, show1]);

  // Modal function
  const handleClose = () => setShowAdd(false);
  const handleShow = () => setShowAdd(true);

  const handleClose1 = () => setShowEdit(0);
  const handleShow1 = (id) => {
    setShowEdit(id);
  };

  //  column hide and show.....
  const [visible, setVisibel] = useState({
    col0: true,
    col1: true,
    col2: true,
    col3: true,
    col4: true,
    col5: true,
    col6: true,
    col7: true,
    col8: true,
    col9: true,
  });

  //toggle columnns.........
  const toggleColumn = (event, columnName) => {
    event.preventDefault();
    setVisibel((prev) => ({
      ...prev,
      [columnName]: !prev[columnName],
    }));
  };

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  useEffect(() => {
    const table = new DataTable("#example");
    return () => {
      table.destroy();
    };
  }, []);

  return (
    <>
      <div className="main-advancedashboard">
        <Header title={"My Subscriptions"} link={"/admin/subscription"} />
        <section className="AdvanceDashboard">
              <section className="Tabels tab-radio tab-radio mt-3">
                <div className="">
                  {/* container */}
                  <div className="row">
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                      <div className="add me-3">
                        {/* {isAllow.includes(IDS.Subscription.Add) ? (
                            <Link
                            
                              type="button"
                              className="btn btn-add pe-3"
                            >
                              <div onClick={() => handleShow()}>
                                <img
                                  src={plus}
                                  className="plus me-2 ms-0"
                                  alt=""
                                />
                                Add Plan
                              </div>
                            </Link>
                          ) : (
                            <></>
                          )} */}
                      </div>

                      <div className="border-line mt-3"></div>
                      <div className="heading-holder mt-4">
                        <h6>My Current Subscription </h6>
                      </div>

                      <div className="package-details-section-top-heading">
                        <div className="pending-table ">
                          {data?.Plan ? (
                            <div className="d-flex  align-items-center">
                              <div className="text-center  ms-5">
                                <Form.Label>Plan</Form.Label>
                                <p>

                                  {data?.plan_name} ({data?.plan_days} days)
                                </p>
                              </div>

                              <div className="text-center  ms-5">
                                <Form.Label>Fair :</Form.Label>
                                <p> {data?.plan_price} /-</p>
                              </div>

                              <div className="text-center  ms-5">
                                <Form.Label>Purchased On :</Form.Label>
                                <p>

                                  {new Date(data?.createdAt).toDateString()}
                                </p>
                              </div>

                              <div className="text-center  ms-5">
                                <Form.Label>Expiring on :</Form.Label>
                                <p>

                                  {new Date(data?.expiry_date).toDateString()}
                                </p>
                              </div>

                              <div className="text-center  ms-5">
                                <Link to={"/subscription/plans"}>
                                  <Button>Renew Plan</Button>
                                </Link>
                              </div>
                            </div>
                          ) : (
                            <div className="d-flex  align-items-center">
                              <div className="text-center  ms-5">
                                <Link to={"/subscription/plans"}>
                                  <Button>Subscribe Now</Button>
                                </Link>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="border-line mt-5"></div>
                  <div className="row mt-3">
                    <h6> Subscription History :</h6>

                    <div className="data table-responsive">
                      <Table striped bordered hover responsive >
                        <thead>
                          <tr className="">
                            {visible.col1 && (
                              <th className="sr" style={{ width: "10%" }}>
                                Sr. No.
                              </th>
                            )}
                            {visible.col2 && (
                              <th className="tax-name" style={{ width: "10%" }}>
                                Purchase Date
                              </th>
                            )}
                            {visible.col3 && (
                              <th className="tax-name" style={{ width: "10%" }}>
                                Expiry Date
                              </th>
                            )}
                            {visible.col4 && (
                              <th className="tax-name" style={{ width: "10%" }}>
                                Plan
                              </th>
                            )}
                            {visible.col5 && (
                              <th className="tax-name" style={{ width: "10%" }}>
                                Price
                              </th>
                            )}
                            {/* {visible.col7 && (
                                <th className="active" style={{ width: "10%" }}>Expiry Date</th>
                              )} */}
                            {/* {visible.col8 && (
                                <th className="active" style={{ width: "10%" }}>Status</th>
                              )} */}
                            {/* {visible.col9 && (
                                <th className="active" style={{ width: "10%" }}>Action</th>
                              )} */}
                          </tr>
                        </thead>
                        <tbody>
                          {data?.Subscription_Histories?.map((d, index) => {
                            return (
                              <tr className="" key={index}>
                                {visible.col1 && <td>{++index}.</td>}
                                {visible.col2 && (
                                  <td>
                                    {new Date(d?.createdAt).toDateString()}
                                  </td>
                                )}
                                {visible.col3 && (
                                  <td>
                                    {new Date(d?.expiry_date).toDateString()}
                                  </td>
                                )}
                                {visible.col4 && (
                                  <td>
                                    {d?.plan_name} ({d?.plan_days} Days)
                                  </td>
                                )}
                                {visible.col5 && <td>{d?.plan_price} /-</td>}
                                {/* {visible.col7 && <td>{(d?.expiry_date)}</td>} */}
                                {/* {visible.col7 && <td>{new Date(d?.expiry_date) > new Date() ? 'Active' : 'Expired'}</td>} */}
                                {/* {visible.col9 && (
                                    <td>
                                      <div className="d-flex">
                                        {isAllow.includes(IDS.Plan.Edit) ? (
                                          <EditButton
                                            handleShow1={handleShow1}
                                            id={d?.id}
                                          />
                                        ) : (
                                          <></>
                                        )}
                                        {isAllow.includes(IDS.Plan.Delete) ? (
                                          <DeletButton
                                            showDeleteRecord={showDeleteRecord}
                                            id={d?.id}
                                            name={d?.name}
                                          />
                                        ) : (
                                          <></>
                                        )}
                                      </div>
                                    </td>
                                  )} */}
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </section>
        </section>
      </div>

      {show ? (
        <AddOffCanvance
          handleClose={handleClose}
          setShow={setShowAdd}
          show={show}
        />
      ) : (
        ""
      )}

      {show1 ? (
        <EditOffCanvance
          handleClose={handleClose1}
          setShow={setShowEdit}
          show={show1}
        />
      ) : (
        ""
      )}

      <ModelBulkUpload
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
      <Toaster position="top-right" />

      <OffcanvasCon show={showoff} handleClose={() => setShowoff(false)} />
    </>
  );
};

export default Tables;
